import { render, staticRenderFns } from "./question-info-shop.vue?vue&type=template&id=31dda8e2&scoped=true&"
import script from "./question-info-shop.vue?vue&type=script&lang=js&"
export * from "./question-info-shop.vue?vue&type=script&lang=js&"
import style0 from "./question-info-shop.vue?vue&type=style&index=0&id=31dda8e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dda8e2",
  null
  
)

export default component.exports